import { IWidgetProps } from "decorator-form";
import React from "react";

export default abstract class BaseWidget<T, V, P = {}> extends React.PureComponent<IWidgetProps<V> & P> {
	protected abstract onChange(data: T, value: V, part: string);

	protected abstract fromValue(value: V): T;

	protected abstract toValue(data: T): string;
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/BaseWidget.ts